
import { Component, OnInit, OnDestroy, ElementRef, ViewChild, HostListener, Inject, PLATFORM_ID  } from '@angular/core';  
import { Data2Service } from 'src/app/services/data2/data2.service';

import { fromEvent, merge, Subscription } from 'rxjs';  
import { tap, switchMap, takeUntil, finalize } from 'rxjs/operators';  
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
  
interface Stock {  
  name: string;  
  points: number;  
  percentage: string;  
}  
@Component({
  selector: 'app-ticker-global-indexes',
  templateUrl: './ticker-global-indexes.component.html',
  styleUrls: ['./ticker-global-indexes.component.scss'],
  standalone:false
})
export class TickerGlobalIndexesComponent {

  @ViewChild('tickerContent', { static: false }) tickerContent!: ElementRef<HTMLDivElement>;     
  @ViewChild('ticker2', { static: false }) ticker2!: ElementRef<HTMLDivElement>;     
  tickerText = "loading ticker...";
  private tickerPos = 0;  
  private animationFrameId!: number;  
  private readonly _speed = 1.2;
  speed = this._speed; // Adjust for faster or slower scrolling  
  halfway = 0;
  private now = new Date();  
  // Set the start date to the first day of next year if today's date is greater than January 3rd  
  start: Date;  

  private dragSub!: Subscription;  
  private dragSpeed = 0;  
  private lastDragTime = 0;  

  latestCommonDate:Date|null = null;
 
  ready=false;
  investments:any = [

    {id:26435, name:'S&P 500 Total Return (1970)'},
    {id:26434, name:'S&P 500 Total Return (1989)'},
    {id:26433, name:'S&P 500 Price Return'},

    {id:25926, name:'DOW<sup>®</sup> Total Return'},
    {id:20666, name:'DOW<sup>®</sup> Price Return'},

    {id:10596, name:'NASDAQ Composite Total Return'},
    {id:26591, name:'NASDAQ Composite Price Return'},   

    {id:1507, name:'Russell 2000<sup>®</sup> Total Return'},
    {id:26592, name:'Russell 2000<sup>®</sup> Price Return'},   

    {id:26443, name:'Germany DAX Total Return'},
    {id:26442, name:'Germany DAX Price Return'},

    {id:26437, name:'Australia  ASX 200 Total Return'},
    {id:26436, name:'Australia ASX 200 Price Return'},

    {id:26453, name:'Canada TSX Total Return'},   
    {id:26452, name:'Canada TSX Price Return'},

    {id:26445, name:'Italy MIB Total Return'},
    {id:26444, name:'Italy MIB Price Return'},

    {id:26447, name:'Spain IBEX 35 Total Return'},
    {id:26446, name:'Spain IBEX 35 Price Return'},

    {id:26449, name:'Netherlands AEX Total Return'},
    {id:26448, name:'Netherlands AEX Price Return'},  

    {id:26439, name:'UK FTSE 100 Total Return'},
    {id:26438, name:'UK FTSE 100 Price Return'},   
    
    {id:26451, name:'Ireland ISEQ Total Return'},
    {id:26450, name:'Ireland ISEQ Price Return'},   

    {id:26441, name:'France CAC 40 Total Return'},
    {id:26440, name:'France CAC 40 Price Return'},   

    
    
   
  ]

  tickerGroups:any=[
    {
      name: "S&P 500",
      stack:[
        {name:"Total Return (1970)", id:26435},
        {name:"Price Return", id:26433},
      ]
    },
    {
      name: "S&P 500",
      stack:[
        {name:"Total Return (1989)", id:26434},
        {name:"Price Return", id:26433},
      ]
    },

    {
      name: "DOW<sup>®</sup>",
      stack:[
        {name:"Total Return", id:25926},
        {name:"Price Return", id:20666},
      ]
    },
    {
      name: "NASDAQ", //(Composite)
      stack:[
        {name:"Total Return", id:10596},
        {name:"Price Return", id:26591},
      ]
    },
    
    {
      name: "Russell 2000<sup>®</sup>",
      stack:[
        {name:"Total Return", id:1507},
        {name:"Price Return", id:26592},
      ]
    },

    {
      name: "Germany DAX",
      stack:[
        {name:"Total Return", id:26443},
        {name:"Price Return", id:26442},
      ]
    },
    {
      name: "Australia ASX 200",
      stack:[
        {name:"Total Return", id:26437},
        {name:"Price Return", id:26436},
      ]
    },
    {
      name: "Canada TSX",
      stack:[
        {name:"Total Return", id:26453},
        {name:"Price Return", id:26452},
      ]
    },
    {
      name: "Italy MIB",
      stack:[
        {name:"Total Return", id:26445},
        {name:"Price Return", id:26444},
      ]
    },
    {
      name: "Spain IBEX 35",
      stack:[
        {name:"Total Return", id:26447},
        {name:"Price Return", id:26446},
      ]
    },
    {
      name: "Netherlands AEX",
      stack:[
        {name:"Total Return", id:26449},
        {name:"Price Return", id:26448},
      ]
    },
    {
      name: "UK FTSE 100",
      stack:[
        {name:"Total Return", id:26439},
        {name:"Price Return", id:26438},
      ]
    },
    {
      name: "Ireland ISEQ",
      stack:[
        {name:"Total Return", id:26451},
        {name:"Price Return", id:26450},
      ]
    },
    {
      name: "France CAC 40",
      stack:[
        {name:"Total Return", id:26441},
        {name:"Price Return", id:26440},
      ]
    }

   
 

  ]

  // @HostListener('window:resize', ['$event'])  
  // onResize(event: Event): void {  
  //   // Reset the ticker position to handle the resized window.  
  //   // This is a simple approach; you might need a more sophisticated  
  //   // reset depending on your layout and requirements.  
  //   this.tickerPos = -this.tickerContent.nativeElement.parentElement!.offsetWidth;  
  //   // Optionally, you could adjust the speed or perform other recalculations here  
  // }  

  ngOnInit(): void {  
    // Subscribe to router events to get the current URL  
    this.router.events.subscribe(() => {  
      this.currentUrl = this.router.url;  
    });  
  }  

  mouseOver(){
    this.speed = 0
  }
  mouseOut(){
    this.speed = this._speed
  }
  ngOnDestroy(): void {  
    if (isPlatformBrowser(this.platformId)) {  
      //safe now to use window
      window.cancelAnimationFrame(this.animationFrameId);  
      if (this.dragSub) {  
        this.dragSub.unsubscribe();  
      }  
    }
  }  


  startTicker(): void { 
    if (isPlatformBrowser(this.platformId)) {  
      //safe now to use window 
      let lastFrameTime = 0;  
      const frameDuration = 1000 / 120; // 30 fps        
      const update = (timestamp: number) => {  
        if (!lastFrameTime) lastFrameTime = timestamp;      
        const elapsed = timestamp - lastFrameTime;      
        if (elapsed >= frameDuration) {  
          this.tickerPos -= this.speed;  
          const maxScroll = this.tickerContent.nativeElement.offsetWidth;  
        this.halfway = this.tickerPos;
          if (this.tickerPos < -this.ticker2.nativeElement.offsetLeft) this.tickerPos = 0;  
          this.tickerContent.nativeElement.style.transform = `translate3d(${this.tickerPos}px, 0, 0)`;  
          lastFrameTime = timestamp;  
        }  
      
        this.animationFrameId = window.requestAnimationFrame(update);  
      };  
      this.animationFrameId = window.requestAnimationFrame(update);  
    }
   
  }  

  initDrag(): void {  
    const tickerElement = this.tickerContent.nativeElement;  

    if (isPlatformBrowser(this.platformId)) {  
      // Safe to use document here  
   
    
      // Mouse events  
      const mouseDown$ = fromEvent(tickerElement, 'mousedown');  
      const mouseMove$ = fromEvent(document, 'mousemove');  
      const mouseUp$ = fromEvent(document, 'mouseup');  

      // Mouse events  
      const mouseEnter$ = fromEvent(tickerElement, 'mouseenter');  
      const mouseLeave$ = fromEvent(tickerElement, 'mouseleave');  
      
      // Touch events  
      const touchStart$ = fromEvent(tickerElement, 'touchstart');  
      const touchMove$ = fromEvent(document, 'touchmove');  
      const touchEnd$ = fromEvent(document, 'touchend');  
      const touchCancel$ = fromEvent(tickerElement, 'touchcancel');  
      
      // Merge mouse and touch events  
      const start$ = merge(mouseDown$, touchStart$);  
      const move$ = merge(mouseMove$, touchMove$);  
      const end$ = merge(mouseUp$, touchEnd$);  

  


      // Handle mouse enter and touch start (equivalent to mouse over)  
      merge(mouseEnter$, touchStart$)  
      .pipe(  
        tap(() => this.mouseOver())  
      )  
      .subscribe();  

    // Handle mouse leave, touch end, and touch cancel (equivalent to mouse out)  
    merge(mouseLeave$, touchEnd$, touchCancel$)  
      .pipe(  
        tap(() => this.mouseOut())  
      )  
      .subscribe();  

    
      
        this.dragSub = start$  
          .pipe(  
            tap((event: any) => {  
              this.speed = 0; // Stop ticker when dragging  
              this.lastDragTime = event.timeStamp;  
              tickerElement.classList.add('dragging'); // Add dragging class  
              event.preventDefault(); // Prevent default behavior  
            //  console.log("event",event)
            }),  
            switchMap((startEvent: any) => {  
              const startX = startEvent instanceof MouseEvent ? startEvent.clientX : startEvent.touches[0].clientX;  
              let lastX = startX;  
      
              return move$.pipe(  
                tap((moveEvent: any) => {  
                // console.log("moveEvent")
                  const currentX = moveEvent instanceof MouseEvent ? moveEvent.clientX : moveEvent.touches[0].clientX;  
                  const deltaX = currentX - lastX;  
                  this.tickerPos += deltaX;  
                  lastX = currentX;  
                  tickerElement.style.transform = `translate3d(${this.tickerPos}px, 0, 0)`;  
                  this.dragSpeed = deltaX / (moveEvent.timeStamp - this.lastDragTime);  
                  this.lastDragTime = moveEvent.timeStamp;  
                  moveEvent.preventDefault(); // Prevent default behavior  
                }),  
                takeUntil(end$),  
                finalize(() => {  
                // console.log("finalize")
                  tickerElement.classList.remove('dragging'); // Remove dragging class  
                  // Apply throw physics  
                  this.applyThrow();  
                })  
              );  
            })  
          )  
          .subscribe();  
        }
    }
      
    
    applyThrow(): void {  
      const applyThrowMotion = () => {  
        if (Math.abs(this.dragSpeed) > 0.01) {  
          this.tickerPos += this.dragSpeed * 16; // Assume ~60fps (16ms per frame)  
          this.dragSpeed *= 0.95; // Apply friction  
          this.tickerContent.nativeElement.style.transform = `translate3d(${this.tickerPos}px, 0, 0)`;  
        // console.log("this.dragSpeed",this.dragSpeed)
          requestAnimationFrame(applyThrowMotion);  
        } else {  
          this.dragSpeed = 0;  
        // this.startTicker(); // Resume ticker motion  
        }  
      };  
      applyThrowMotion();  
    }  
    
  

  currentUrl: string = '';  
  constructor(private data2Service:Data2Service, private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {


    if (this.now > new Date(this.now.getFullYear(), 0, 3)) { // Check if today is after January 3rd  
      this.start = new Date(Date.UTC(this.now.getUTCFullYear() + 1, 0, 1));  
  } else {  
      // Optional: define 'start' for other cases or leave it undefined  
      this.start = new Date(Date.UTC(this.now.getUTCFullYear(), 0, 1)); // Use the current year if not specified otherwise  
  }  
  
   

    // var weekdays = this.getPreviousWeekdays();
    // weekdays[]
    // //console.log("weekdays",weekdays)

    let startYear = this.start.getFullYear()

    //this.data2Service.investmentPerformanceDailyIndexGRR$(this.investments.map((x:any)=>x.id).join(','),weekdays[2],"end",1,true).subscribe((resp:any)=>{
    //console.log("this.investments",this.investments, this.investments.map((x:any)=>x.id).join(','),startYear)
    this.data2Service.investmentPerformanceDailyIndexGRR$(this.investments.map((x:any)=>x.id).join(','),`1/1/${startYear}`,"end",1,true).subscribe((resp:any)=>{
      
      if(resp && resp.results && resp.results.data){
          //console.log("investmentPerformanceDailyIndexGRR",resp);

          resp.results.data = resp.results.data.filter((x:any) => x.periods != null);  
          //console.log("resp",resp)

          let lastDates = resp.results.data.map((x:any)=>new Date(x.periods[0].indexDates[x.periods[0].indexDates.length-1]));
          //console.log("lastDates",lastDates)

          lastDates.sort((a: Date, b: Date) => {  
            return a.getTime() - b.getTime();  
          });  

          this.latestCommonDate = lastDates[0];
          lastDates=null;


        

        

          for(let i=0;i<resp.results.data.length;i++){
            for(let j=0;j<this.investments.length;j++){
              if(this.investments[j].id==resp.results.data[i].id){
                if(resp.results.data[i].periods != null && resp.results.data[i].periods.length>0){
                  this.investments[j].endingValue = resp.results.data[i].periods[0].endingValue;
                  this.investments[j].subtitle = resp.results.data[i].periods[0].subtitle;

                  if(resp.results.data[i].periods[0].indexValues && resp.results.data[i].periods[0].indexValues.length>0){
                    let _k = resp.results.data[i].periods[0].indexValues[0];
                  
                    this.investments[j]._points = 0;
                    this.investments[j]._percent = 0;
                    for(let k=0;k<resp.results.data[i].periods[0].indexValues.length;k++){
                      if(this.latestCommonDate!=null && new Date(resp.results.data[i].periods[0].indexDates[k])<=this.latestCommonDate && resp.results.data[i].periods[0].indexValues[k]!=_k){

                        
                        this.investments[j]._points = ((resp.results.data[i].periods[0].indexValues[k]-_k)>0?"+":"") +(resp.results.data[i].periods[0].indexValues[k]-_k).toFixed(2);
                        this.investments[j]._percent = (((resp.results.data[i].periods[0].indexValues[k]/_k)-1)*100).toFixed(2);
                        _k=resp.results.data[i].periods[0].indexValues[k];
                      }
                    }
                  }             
                }
              }
            }
          }
          //tickerGroups
          for (let i = 0; i < resp.results.data.length; i++) {
              for (let j = 0; j < this.tickerGroups.length; j++) {
                  for (let l = 0; l < this.tickerGroups[j].stack.length; l++) {
                      if (this.tickerGroups[j].stack[l].id == resp.results.data[i].id) {                   
                          if (resp.results.data[i].periods !=null && resp.results.data[i].periods.length > 0) {
                              this.tickerGroups[j].stack[l].endingValue = resp.results.data[i].periods[0].endingValue;
                              this.tickerGroups[j].stack[l].subtitle = resp.results.data[i].periods[0].subtitle;

                              if (resp.results.data[i].periods[0].indexValues !=null && resp.results.data[i].periods[0].indexValues.length > 0) {
                                  let _k = resp.results.data[i].periods[0].indexValues[0];
                                  this.tickerGroups[j].stack[l]._points = 0;
                                  this.tickerGroups[j].stack[l]._percent = 0;
                                  for (let k = 0; k < resp.results.data[i].periods[0].indexValues.length; k++) {
                                      if (this.latestCommonDate!=null && new Date(resp.results.data[i].periods[0].indexDates[k])<=this.latestCommonDate && resp.results.data[i].periods[0].indexValues[k] != _k) {
                                          this.tickerGroups[j].stack[l]._points = ((resp.results.data[i].periods[0].indexValues[k] - _k) > 0 ? "+" : "") + (resp.results.data[i].periods[0].indexValues[k] - _k).toFixed(2);
                                          this.tickerGroups[j].stack[l]._percent = (((resp.results.data[i].periods[0].indexValues[k] / _k) - 1) * 100).toFixed(2);
                                          // this.tickerGroups[j].stack[l]._ytd = (resp.results.data[i].periods[0]._totalReturn).toFixed(2); //DONT use this one, because you want the end dates to sync
                                          this.tickerGroups[j].stack[l]._ytdCalc = ((resp.results.data[i].periods[0].indexValues[k]/resp.results.data[i].periods[0].indexValues[0]-1)*100).toFixed(2);
                                          
                                          _k = resp.results.data[i].periods[0].indexValues[k];
                                          this.tickerGroups[j].stack[l].endingValue = _k;
                                      }
                                  }
                              }
                          }
                      }
                  }
              }
          }

          this.tickerGroups = this.tickerGroups.filter((tickerGroup:any) =>   
            tickerGroup.stack.every((stack:any) => stack.hasOwnProperty('endingValue'))  
          );  

          //console.log("this.tickerGroups",this.tickerGroups)
          
      

          //console.log("latestCommonDate",this.latestCommonDate)


          

          this.ready=true;
          this.startTicker();  
          setTimeout(()=>{
            this.initDrag();  
          },1000)
        
        // console.log("investments",this.investments)

      }
      else{
        this.tickerText = "Error Loading Ticker Data";
      }

    });
  
  
  }


  getPreviousWeekdays(): string[] {  
    const days = [];  
    const date = new Date();  
    for (let i = 1; i <= 7; i++) {  
        date.setDate(date.getDate() - 1);  
        if (date.getDay() !== 0 && date.getDay() !== 6) {  
            days.push(this.formatDate(date));  
            if (days.length === 3) break;  
        }  
    }  
    return days;  
}  
  
 formatDate(date: Date): string {  
    const day = date.getDate();  
    const month = date.getMonth() + 1; // Month count starts from 0  
    const year = date.getFullYear();  
    return `${month}/${day}/${year}`;  
}  

}
